<template>
  <div>
    <NavBar :admin="true" :items="items" />
    <v-main>
      <v-container v-if="!loading">
        <p class="text-h5 mt-2" v-translate>Data Consent</p>
        <p class="title mt-2" v-translate>Older</p>
        PT
        <RichTextEditor key="data-pt" ref="dataPT" :text="patient_data_consent_pt" />
        EN
        <RichTextEditor key="data-en" ref="dataEN" :text="patient_data_consent_en" />
        ES
        <RichTextEditor key="data-es" ref="dataES" :text="patient_data_consent_es" />
        <p class="title mt-2" v-translate>Minor</p>
        PT
        <RichTextEditor key="data-minor-pt" ref="dataMinorPT" :text="patient_data_consent_minor_pt" />
        EN
        <RichTextEditor key="data-minor-en" ref="dataMinorEN" :text="patient_data_consent_minor_en" />
        ES
        <RichTextEditor key="data-minor-es" ref="dataMinorES" :text="patient_data_consent_minor_es" />
        <v-divider class="my-5"></v-divider>
        <p class="text-h5 mt-2" v-translate>Terapeutic Consent</p>
        <p class="title mt-2" v-translate>TCM</p>
        <p class="title mt-2" v-translate>Older</p>
        PT
        <RichTextEditor key="terapeutic-tcm-pt" ref="terapeuticTCMPT" :text="patient_terapeutic_consent_tcm_pt" />
        EN
        <RichTextEditor key="terapeutic-tcm-en" ref="terapeuticTCMEN" :text="patient_terapeutic_consent_tcm_en" />
        ES
        <RichTextEditor key="terapeutic-tcm-es" ref="terapeuticTCMES" :text="patient_terapeutic_consent_tcm_es" />
        <p class="title mt-2" v-translate>Minor</p>
        PT
        <RichTextEditor key="terapeutic-tcm-minor-pt" ref="terapeuticTCMMinorPT" :text="patient_terapeutic_consent_tcm_minor_pt" />
        EN
        <RichTextEditor key="terapeutic-tcm-minor-en" ref="terapeuticTCMMinorEN" :text="patient_terapeutic_consent_tcm_minor_en" />
        ES
        <RichTextEditor key="terapeutic-tcm-minor-es" ref="terapeuticTCMMinorES" :text="patient_terapeutic_consent_tcm_minor_es" />
        <p class="title mt-2" v-translate>Fitotherapy</p>
        <p class="title mt-2" v-translate>Older</p>
        PT
        <RichTextEditor key="terapeutic-fito-pt" ref="terapeuticFitoPT" :text="patient_terapeutic_consent_fito_pt" />
        EN
        <RichTextEditor key="terapeutic-fito-en" ref="terapeuticFitoEN" :text="patient_terapeutic_consent_fito_en" />
        ES
        <RichTextEditor key="terapeutic-fito-es" ref="terapeuticFitoES" :text="patient_terapeutic_consent_fito_es" />
        <p class="title mt-2" v-translate>Minor</p>
        PT
        <RichTextEditor key="terapeutic-fito-minor-pt" ref="terapeuticFitoMinorPT" :text="patient_terapeutic_consent_fito_minor_pt" />
        EN
        <RichTextEditor key="terapeutic-fito-minor-en" ref="terapeuticFitoMinorEN" :text="patient_terapeutic_consent_fito_minor_en" />
        ES
        <RichTextEditor key="terapeutic-fito-minor-es" ref="terapeuticFitoMinorES" :text="patient_terapeutic_consent_fito_minor_es" />
        <p class="title mt-2" v-translate>Osteopathy</p>
        <p class="title mt-2" v-translate>Older</p>
        PT
        <RichTextEditor key="terapeutic-osteo-pt" ref="terapeuticOsteoPT" :text="patient_terapeutic_consent_osteo_pt" />
        EN
        <RichTextEditor key="terapeutic-osteo-en" ref="terapeuticOsteoEN" :text="patient_terapeutic_consent_osteo_en" />
        ES
        <RichTextEditor key="terapeutic-osteo-es" ref="terapeuticOsteoES" :text="patient_terapeutic_consent_osteo_es" />
        <p class="title mt-2" v-translate>Minor</p>
        PT
        <RichTextEditor key="terapeutic-osteo-minor-pt" ref="terapeuticOsteoMinorPT" :text="patient_terapeutic_consent_osteo_minor_pt" />
        EN
        <RichTextEditor key="terapeutic-osteo-minor-en" ref="terapeuticOsteoMinorEN" :text="patient_terapeutic_consent_osteo_minor_en" />
        ES
        <RichTextEditor key="terapeutic-osteo-minor-es" ref="terapeuticOsteoMinorES" :text="patient_terapeutic_consent_osteo_minor_es" />
        <v-row no-gutters class="mt-2">
          <v-alert v-model="error" color="red" icon="warning">
						<translate>Error</translate>
					</v-alert>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" @click="save" :loading="loading">
            <translate>Save</translate>
          </v-btn>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import RichTextEditor from "@/components/RichTextEditor.vue";
import axios from "axios";

export default {
  name: "PatientConsent",
  components: {
    NavBar,
    RichTextEditor
  },
  data: () => ({
    patient_data_consent_pt: "",
    patient_data_consent_en: "",
    patient_data_consent_es: "",
    patient_data_consent_minor_pt: "",
    patient_data_consent_minor_en: "",
    patient_data_consent_minor_es: "",
    patient_terapeutic_consent_tcm_pt: "",
    patient_terapeutic_consent_tcm_en: "",
    patient_terapeutic_consent_tcm_es: "",
    patient_terapeutic_consent_tcm_minor_pt: "",
    patient_terapeutic_consent_tcm_minor_en: "",
    patient_terapeutic_consent_tcm_minor_es: "",
    patient_terapeutic_consent_fito_pt: "",
    patient_terapeutic_consent_fito_en: "",
    patient_terapeutic_consent_fito_es: "",
    patient_terapeutic_consent_fito_minor_pt: "",
    patient_terapeutic_consent_fito_minor_en: "",
    patient_terapeutic_consent_fito_minor_es: "",
    patient_terapeutic_consent_osteo_pt: "",
    patient_terapeutic_consent_osteo_en: "",
    patient_terapeutic_consent_osteo_es: "",
    patient_terapeutic_consent_osteo_minor_pt: "",
    patient_terapeutic_consent_osteo_minor_en: "",
    patient_terapeutic_consent_osteo_minor_es: "",
    loading: true,
    error: false
  }),
  computed: {
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: this.$gettext("Patient Consent"),
					disabled: true,
					link: true
				}
			];
    },
    required() {
			return value => !!value || this.$gettext("Required.");
		}
  },
  methods: {
    save() {
      this.loading = true;
      let text_data_pt = this.$refs.dataPT.getHTML();
      let text_data_en = this.$refs.dataEN.getHTML();
      let text_data_es = this.$refs.dataES.getHTML();
      let text_data_minor_pt = this.$refs.dataMinorPT.getHTML();
      let text_data_minor_en = this.$refs.dataMinorEN.getHTML();
      let text_data_minor_es = this.$refs.dataMinorES.getHTML();
      
      let text_terapeutic_tcm_pt = this.$refs.terapeuticTCMPT.getHTML();
      let text_terapeutic_tcm_en = this.$refs.terapeuticTCMEN.getHTML();
      let text_terapeutic_tcm_es = this.$refs.terapeuticTCMES.getHTML();
      let text_terapeutic_tcm_minor_pt = this.$refs.terapeuticTCMMinorPT.getHTML();
      let text_terapeutic_tcm_minor_en = this.$refs.terapeuticTCMMinorEN.getHTML();
      let text_terapeutic_tcm_minor_es = this.$refs.terapeuticTCMMinorES.getHTML();

      let text_terapeutic_fito_pt = this.$refs.terapeuticFitoPT.getHTML();
      let text_terapeutic_fito_en = this.$refs.terapeuticFitoEN.getHTML();
      let text_terapeutic_fito_es = this.$refs.terapeuticFitoES.getHTML();
      let text_terapeutic_fito_minor_pt = this.$refs.terapeuticFitoMinorPT.getHTML();
      let text_terapeutic_fito_minor_en = this.$refs.terapeuticFitoMinorEN.getHTML();
      let text_terapeutic_fito_minor_es = this.$refs.terapeuticFitoMinorES.getHTML();

      let text_terapeutic_osteo_pt = this.$refs.terapeuticOsteoPT.getHTML();
      let text_terapeutic_osteo_en = this.$refs.terapeuticOsteoEN.getHTML();
      let text_terapeutic_osteo_es = this.$refs.terapeuticOsteoES.getHTML();
      let text_terapeutic_osteo_minor_pt = this.$refs.terapeuticOsteoMinorPT.getHTML();
      let text_terapeutic_osteo_minor_en = this.$refs.terapeuticOsteoMinorEN.getHTML();
      let text_terapeutic_osteo_minor_es = this.$refs.terapeuticOsteoMinorES.getHTML();
      const formData = new FormData();
      formData.append("patient_data_consent_pt", text_data_pt);
      formData.append("patient_data_consent_en", text_data_en);
      formData.append("patient_data_consent_es", text_data_es);
      formData.append("patient_data_consent_minor_pt", text_data_minor_pt);
      formData.append("patient_data_consent_minor_en", text_data_minor_en);
      formData.append("patient_data_consent_minor_es", text_data_minor_es);
      formData.append("patient_terapeutic_consent_tcm_pt", text_terapeutic_tcm_pt);
      formData.append("patient_terapeutic_consent_tcm_en", text_terapeutic_tcm_en);
      formData.append("patient_terapeutic_consent_tcm_es", text_terapeutic_tcm_es);
      formData.append("patient_terapeutic_consent_tcm_minor_pt", text_terapeutic_tcm_minor_pt);
      formData.append("patient_terapeutic_consent_tcm_minor_en", text_terapeutic_tcm_minor_en);
      formData.append("patient_terapeutic_consent_tcm_minor_es", text_terapeutic_tcm_minor_es);
      formData.append("patient_terapeutic_consent_fito_pt", text_terapeutic_fito_pt);
      formData.append("patient_terapeutic_consent_fito_en", text_terapeutic_fito_en);
      formData.append("patient_terapeutic_consent_fito_es", text_terapeutic_fito_es);
      formData.append("patient_terapeutic_consent_fito_minor_pt", text_terapeutic_fito_minor_pt);
      formData.append("patient_terapeutic_consent_fito_minor_en", text_terapeutic_fito_minor_en);
      formData.append("patient_terapeutic_consent_fito_minor_es", text_terapeutic_fito_minor_es);
      formData.append("patient_terapeutic_consent_osteo_pt", text_terapeutic_osteo_pt);
      formData.append("patient_terapeutic_consent_osteo_en", text_terapeutic_osteo_en);
      formData.append("patient_terapeutic_consent_osteo_es", text_terapeutic_osteo_es);
      formData.append("patient_terapeutic_consent_osteo_minor_pt", text_terapeutic_osteo_minor_pt);
      formData.append("patient_terapeutic_consent_osteo_minor_en", text_terapeutic_osteo_minor_en);
      formData.append("patient_terapeutic_consent_osteo_minor_es", text_terapeutic_osteo_minor_es);
      axios
        .post("/admin/patient-consent", formData)
        .then(response => {
          console.log(response.data);
          if (response.status === 200) {
            this.patient_data_consent_pt = response.data.patient_data_consent_pt;
            this.patient_data_consent_en = response.data.patient_data_consent_en;
            this.patient_data_consent_es = response.data.patient_data_consent_es;
            this.patient_data_consent_minor_pt = response.data.patient_data_consent_minor_pt;
            this.patient_data_consent_minor_en = response.data.patient_data_consent_minor_en;
            this.patient_data_consent_minor_es = response.data.patient_data_consent_minor_es;
            this.patient_terapeutic_consent_tcm_pt = response.data.patient_terapeutic_consent_tcm_pt;
            this.patient_terapeutic_consent_tcm_en = response.data.patient_terapeutic_consent_tcm_en;
            this.patient_terapeutic_consent_tcm_es = response.data.patient_terapeutic_consent_tcm_es;
            this.patient_terapeutic_consent_tcm_minor_pt = response.data.patient_terapeutic_consent_tcm_minor_pt;
            this.patient_terapeutic_consent_tcm_minor_en = response.data.patient_terapeutic_consent_tcm_minor_en;
            this.patient_terapeutic_consent_tcm_minor_es = response.data.patient_terapeutic_consent_tcm_minor_es;
            this.patient_terapeutic_consent_fito_pt = response.data.patient_terapeutic_consent_fito_pt;
            this.patient_terapeutic_consent_fito_en = response.data.patient_terapeutic_consent_fito_en;
            this.patient_terapeutic_consent_fito_es = response.data.patient_terapeutic_consent_fito_es;
            this.patient_terapeutic_consent_fito_minor_pt = response.data.patient_terapeutic_consent_fito_minor_pt;
            this.patient_terapeutic_consent_fito_minor_en = response.data.patient_terapeutic_consent_fito_minor_en;
            this.patient_terapeutic_consent_fito_minor_es = response.data.patient_terapeutic_consent_fito_minor_es;
            this.patient_terapeutic_consent_osteo_pt = response.data.patient_terapeutic_consent_osteo_pt;
            this.patient_terapeutic_consent_osteo_en = response.data.patient_terapeutic_consent_osteo_en;
            this.patient_terapeutic_consent_osteo_es = response.data.patient_terapeutic_consent_osteo_es;
            this.patient_terapeutic_consent_osteo_minor_pt = response.data.patient_terapeutic_consent_osteo_minor_pt;
            this.patient_terapeutic_consent_osteo_minor_en = response.data.patient_terapeutic_consent_osteo_minor_en;
            this.patient_terapeutic_consent_osteo_minor_es = response.data.patient_terapeutic_consent_osteo_minor_es;
            this.loading = false;
          }
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
          this.error = true;
        });
    }
  },
  created() {
    axios
      .get("/admin/patient-consent")
      .then(response => {
        if (response.status === 200) {
          this.patient_data_consent_pt = response.data.patient_data_consent_pt;
          this.patient_data_consent_en = response.data.patient_data_consent_en;
          this.patient_data_consent_es = response.data.patient_data_consent_es;
          this.patient_data_consent_minor_pt = response.data.patient_data_consent_minor_pt;
          this.patient_data_consent_minor_en = response.data.patient_data_consent_minor_en;
          this.patient_data_consent_minor_es = response.data.patient_data_consent_minor_es;
          this.patient_terapeutic_consent_tcm_pt = response.data.patient_terapeutic_consent_tcm_pt;
          this.patient_terapeutic_consent_tcm_en = response.data.patient_terapeutic_consent_tcm_en;
          this.patient_terapeutic_consent_tcm_es = response.data.patient_terapeutic_consent_tcm_es;
          this.patient_terapeutic_consent_tcm_minor_pt = response.data.patient_terapeutic_consent_tcm_minor_pt;
          this.patient_terapeutic_consent_tcm_minor_en = response.data.patient_terapeutic_consent_tcm_minor_en;
          this.patient_terapeutic_consent_tcm_minor_es = response.data.patient_terapeutic_consent_tcm_minor_es;
          this.patient_terapeutic_consent_fito_pt = response.data.patient_terapeutic_consent_fito_pt;
          this.patient_terapeutic_consent_fito_en = response.data.patient_terapeutic_consent_fito_en;
          this.patient_terapeutic_consent_fito_es = response.data.patient_terapeutic_consent_fito_es;
          this.patient_terapeutic_consent_fito_minor_pt = response.data.patient_terapeutic_consent_fito_minor_pt;
          this.patient_terapeutic_consent_fito_minor_en = response.data.patient_terapeutic_consent_fito_minor_en;
          this.patient_terapeutic_consent_fito_minor_es = response.data.patient_terapeutic_consent_fito_minor_es;
          this.patient_terapeutic_consent_osteo_pt = response.data.patient_terapeutic_consent_osteo_pt;
          this.patient_terapeutic_consent_osteo_en = response.data.patient_terapeutic_consent_osteo_en;
          this.patient_terapeutic_consent_osteo_es = response.data.patient_terapeutic_consent_osteo_es;
          this.patient_terapeutic_consent_osteo_minor_pt = response.data.patient_terapeutic_consent_osteo_minor_pt;
          this.patient_terapeutic_consent_osteo_minor_en = response.data.patient_terapeutic_consent_osteo_minor_en;
          this.patient_terapeutic_consent_osteo_minor_es = response.data.patient_terapeutic_consent_osteo_minor_es;
          this.loading = false;
        }
      })
      .catch(error => {
        console.log(error)
        this.loading = false;
        this.error = true;
      });
  }
}
</script>